import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css"; // Ensure Tailwind styles are included

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

const runWhenIdle = (callback: () => void) => {
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(callback, { timeout: 2_500 });
    return;
  }

  globalThis.setTimeout(callback, 0);
};

if (import.meta.env.VITE_SENTRY_DSN) {
  runWhenIdle(() => {
    void import("./sentry");
  });
}

if (import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN) {
  runWhenIdle(() => {
    void import("./posthog");
  });
}
